// @flow
// Top-level error handler.
// https://facebook.github.io/react/blog/2017/07/26/error-handling-in-react-16.html
import * as React from "react"
import Button from "material-ui/RaisedButton"

// hell if I know the correct types here
type Error = ?Object
type ErrorInfo = ?Object
export default class ErrorHandler extends React.Component<
  {children: *},
  {error: Error, errorInfo: ErrorInfo},
> {
  constructor(props: *) {
    super(props)
    // can't reuse onClear() here. Ctor requires `this.state = x` to avoid
    // logged warnings; all other places require `this.setState(x)`.
    this.state = {error: null, errorInfo: null}
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({error, errorInfo})
    console.error("ErrorHandler", {error, errorInfo})
  }
  onClear = () => {
    this.setState({error: null, errorInfo: null})
  }
  report = () => {
    window.FreshWidget.show()
    return false
  }
  render() {
    if (this.state && this.state.error) {
      const reportButton = (
        <Button primary label="report error" onClick={this.report} />
      )
      const clearButton = (
        <Button secondary label="clear error" onClick={this.onClear} />
      )
      return (
        <div
          style={{
            background: "darkred",
            color: "white",
            padding: 20,
            margin: 0,
          }}
        >
          <div title="My face is as red as this screen.">
            <h1>It broke.</h1>
            <p>
              Sorry about this. Please {reportButton} and I'll have it fixed
              soon.
            </p>
            <p>You can also refresh the page, or {clearButton}</p>
          </div>
          <pre>
            <h2>{this.state.error.toString()}</h2>
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <div>
            {reportButton}
            {clearButton}
          </div>
        </div>
      )
    }
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/nav/ErrorHandler.js